export const offer = {
  name: 'Le Système Complet du Coach',
  method: 'La méthode CAP™',
  price: '25',
  currency: '€ TTC',
  guaranteeDays: '[14]',
  supportEmail: '[EMAIL SUPPORT]',
  socialNetwork: '[RÉSEAU SOCIAL]',
  mediator: '[NOM ET COORDONNÉES]',
  checkoutUrl:
    'https://the-life-coach-s-complete-system.impultienda.ar/checkout',
}

export const trustItems = [
  'Paiement sécurisé',
  'Accès immédiat',
  `Garantie de ${offer.guaranteeDays} jours`,
  '100 % numérique (PDF imprimables)',
]

export const heroBadges = [
  '6 tomes',
  '5 bonus',
  '23 fiches numérotées',
  'Séance Zéro minutée en 75 minutes',
  'Écrit pour le cadre français',
]

export const proofMetrics = [
  {
    figure: '6 + 5',
    label: 'Tomes et bonus',
  },
  {
    figure: '23',
    label: 'Fiches numérotées, à utiliser en séance',
  },
  {
    figure: '10 séances · 3 phases',
    label: 'Fondations, Élan, Intégration',
  },
  {
    figure: 'De la Séance Zéro au bilan de clôture',
    label: 'Tout le parcours, séance par séance',
  },
]

export const revealStats = [
  { figure: '6', label: 'tomes' },
  { figure: '23', label: 'fiches numérotées' },
  { figure: '75 min', label: 'Séance Zéro minutée' },
  { figure: '12', label: 'trames de séance' },
]

export const coverageChips = [
  'Accueil et diagnostic',
  'Croyances',
  'Passage à l’action',
  'Client qui stagne',
  'Clôture',
  'Pratique professionnelle en France',
]

export const capSteps = [
  {
    letter: 'C',
    title: 'Comprendre',
    body: 'ce qui se joue vraiment, au-delà de l’objectif annoncé.',
  },
  {
    letter: 'A',
    title: 'Aligner',
    body: 'le client sur une feuille de route co-construite en trois phases.',
  },
  {
    letter: 'P',
    title: 'Prouver',
    body: 'au début de chaque séance, un changement concret déjà obtenu.',
  },
]
